import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Azienda, Environment, GenericResponse } from 'src/app/entities/various';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UserService } from 'src/app/services/users/user.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-company-modal',
  templateUrl: './company-modal.component.html',
  styleUrls: ['./company-modal.component.css']
})

export class CompanyModalComponent implements OnInit {

  @Input() userId : any | undefined;
  @Input() returnData : any | undefined;

  azienda: Azienda;
  me: UserInfo | undefined;
  toastConfig: { title: string, class: string } | undefined;

  formatterEnv = (environment: Environment) => environment.name;
  searchEnv = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(term => term.length < 2 ? []
        : this.userService.cercaAmbienti(term)
      )
    )

  constructor(public translate: TranslateService, 
    public activeModal: NgbActiveModal, 
    private toast : ToastService, 
    private userService: UserService,
    private loginService: LoginService) { 
      this.azienda = {
        denominazione : "",
        environment: null,
        environment_id : "",
        partitaiva : "",
        codicefiscale : "",
        email : ""
      }
    }

  async ngOnInit(): Promise<void> {
  
    this.me = await this.loginService.getUserInfo();
    if (this.me?.role != "S") {
      this.azienda.environment_id = this.me!.environment_id;
    }
   
  }

  close(){
    this.activeModal.close(false);
  }

  closeWithData(response :any){
    this.activeModal.close(response);
  }

  async salva() {
    let res = await this.userService.creaAzienda(this.azienda, this.me!.dms_user_id);
    if (res.success) {
      this.toast.openToastWithConfig(true, 5000, res.msg, "success");
      if(this.returnData==true)
          this.closeWithData(res);
      else
        this.close();

    } else {
      this.toast.openToast(res.msg, "warning");
    }
  }


}
